import stringify from 'fast-safe-stringify';

export const removeCircularReferences = (value: any) => {
    const stringifiedPage = stringify(value);
    return JSON.parse(stringifiedPage);
};
